import {
  Dialog,
  Button,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Popover,
  Loading
} from 'element-ui'
export default {
  Dialog,
  Button,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Popover,
  Loading
}
